var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"patient"},[_c('div',{staticClass:"reminder"},[_vm._v(" 最多可添加6人 ")]),_c('patient-list',{attrs:{"list":_vm.list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }